












import Vue from "vue"
export default Vue.extend({
  name: 'notificationerror',
  props: {
    title: String,
    message: String
  },
})
